/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/* file contains the settings used for the application */

export const ENCRYPTION_KEY = 'jWnZr4u7x!A%C*F-JaNdRgUkXp2s5v8y';

export const IMAGE_TYPES =  'image/gif, image/jpeg, image/png, image/heic, image/heif, image/webp';

export const VIDEO_TYPES = 'video/mp4, video/avi, video/webm, video/quicktime';

export const DATE_FORMAT = 'dd/MM/yyyy';

export const TIME_FORMAT = 'hh:mm';

export const DATETIME_FORMAT = 'dd/MM/yyyy, HH:mm';

export const MAX_LIMIT = 5000;

export const BUYER_URL = "https://buyeruat.ctbids.com";
export const FEE_TYPE_LIST = [{
    name: "Packing",
    key: "packingamount"
}, {
    name: "Shipping",
    key: "shippinghandling"
}, {
    name: "Handling",
    key: "handling"
}, {
    name: "Delivery",
    key: "deliveryamount"
}, {
    name: "Additional Items Purchased",
    key: "additionalitem"
}, {
    name: "Additional Services or Fees",
    key: "additionalamount"
}, {
    name: "Tax",
    key: "taxamount"
}, {
    name: "Other",
    key: "otheramount"
}]

export const CATERGORY = ["Ammo", "Firearms", "Gun Parts"];

export const SUSPENSION_REASON = ["Non Payment - Item", "Non Payment - Shipping", "Fraudulent Behavior", "Inappropriate Behavior"];

export const UNSUSPENSION_REASON = ["Customer Paid Unpaid Invoice", "Customer Paid Unpaid Shipping Invoice", "Resolved Issues with Customer", "Other - See Notes"]

export const SUPPORT_WIDGET_SRC = 'https://supportuat.ctbids.com/widget.js';

export const SUPPORT_WIDGET_APP_URL = 'https://supportuat.ctbids.com';